/**
 * Merge multiple objects into one.
 */
export function merge<T>(...obj: T[]): T {
  return Object.assign({}, ...obj);
}
